import { InfoGetbannerResp } from 'app/bff/models/info/infoGetbanner';
import { InfoGetproductfeatureResp } from 'app/bff/models/info/infoGetproductfeature';
import { InfoGetpagephraseResp } from 'app/bff/models/info/infoGetpagephrase';
import { InfoGetrecomplanResp } from 'app/bff/models/info/infoGetrecomplan';
import { InfoGetqaResp } from 'app/bff/models/info/infoGetqa';
import { InfoGetproductResp } from 'app/bff/models/info/infoGetproduct';

export interface RouteLocationState {
  sectionId: SectionIdEnum;
}

export interface PageDataSourceState {
  indexShowcase: InfoGetbannerResp['banner'];
  productFeatures: InfoGetproductfeatureResp | null;
  insuranceCoverages: InfoGetpagephraseResp['limitations'];
  recommendationPlans: InfoGetrecomplanResp['recommendPlans'];
  insureLimits: InfoGetpagephraseResp['limitations'];
  insureRegulations: InfoGetpagephraseResp['limitations'];
  claimCases: InfoGetpagephraseResp['limitations'];
  claimDocuments: InfoGetpagephraseResp['limitations'];
  insuranceQA: InfoGetqaResp | null;
  moreProducts: InfoGetproductResp['products'];
}

export enum SectionIdEnum {
  IndexShowcase = 'index-showcase',
  ProductFeatures = 'product-features',
  InsuranceCoverages = 'insurance-coverages',
  PremiumEvalCalculation = 'premium-eval-calculation',
  RecommendationPlans = 'recommendation-plans',
  InsureLimits = 'insure-limits',
  InsureRegulations = 'insure-regulations',
  ClaimCases = 'claim-cases',
  InsuranceQA = 'insurance-QA',
  MoreProducts = 'more-products'
}

export enum SectionNameEnum {
  IndexShowcase = 'E定好定期壽險',
  ProductFeatures = '商品特色',
  InsuranceCoverages = '保障內容',
  PremiumEvalCalculation = '保費試算',
  RecommendationPlans = '熱門推薦',
  InsureLimits = '投保限制',
  InsureRegulations = '投保規定',
  ClaimCases = '理賠案例',
  InsuranceQA = '小百科',
  MoreProducts = '更多商品'
}
